export default {
    openapp: "Open APP",
    noStore: "Stores don't exist",
    rating: "Rating:",
    Categories: "Categories:",
    PreparationTime: "Preparation time:",
    DeliveryFee: "Delivery Fee",
    FreeDelivery:"Free Delivery",
    noScore: 'No reviews',
    discountTitle: 'Discount',
    fullReductionTitle: 'Full Reduce Offer',
    storeFirstTitle: 'First Order',
    couponTitle: 'Coupon',
}